import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["sticky"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTHead = styled.thead.withConfig({
  displayName: "TableHead__StyledTHead",
  componentId: "g7tifj-0"
})(({
  $sticky,
  $cssStyles
}) => {
  return Object.assign({}, $sticky && {
    position: 'sticky',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1 // Reminder: was MERCURY_LAYER from HubStyleTokens
  }, $cssStyles);
});
export const TableHead = _ref => {
  let {
      sticky
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    callbackProps,
    tokenProps,
    restProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledTHead, Object.assign({}, domProps, callbackProps, restProps, {
    $sticky: sticky,
    $cssStyles: cssStyles
  }));
};